/**
 * Project : workspace
 * File    : StoreMenuConfig.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package common.constants

import androidx.compose.ui.graphics.Color
import com.parmartechnologies.app.composeapp.generated.resources.Res
import com.parmartechnologies.app.composeapp.generated.resources.colors
import com.parmartechnologies.app.composeapp.generated.resources.dashboard_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.invoice_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.orders_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.sale_menu_icon
import com.parmartechnologies.app.composeapp.generated.resources.shop_menu_icon
import com.parmartechnologies.business.feature.businessMenu.modal.BusinessMenu
import com.parmartechnologies.business.feature.businessMenu.modal.MenuType
import locale.localization
import navigation.route.business.BusinessNavRoute
import navigation.route.business.store.BusinessStoreNavRoute
import navigation.route.order.OrderNavRoute
import navigation.route.store.StoreNavRoute
import navigation.route.store.account.StoreAccountNavRoute
import navigation.route.store.currency.StoreCurrencyNavRoute

/**
 * Represents the store menu config class.
 */

class StoreMenuConfig {
    fun getMenu(): List<BusinessMenu> {
        val firstMenu: ArrayList<BusinessMenu> = arrayListOf()
        firstMenu.add(
            BusinessMenu(
                "my_business_orders",
                MenuType.MENU,
                "Orders",
                Res.drawable.orders_menu_icon,
                OrderNavRoute.LIST,
                Color(0xFFE3F5E2)
            )
        )

        val secondMenu: ArrayList<BusinessMenu> = arrayListOf()
        secondMenu.add(
            BusinessMenu(
                "my_business_currency",
                MenuType.MENU,
                localization().storeMenu.currencyInr,
                Res.drawable.invoice_menu_icon,
                StoreCurrencyNavRoute.HOME,
                Color(0xFFE3F5E2)
            )
        )
        secondMenu.add(
            BusinessMenu(
                "my_business_back_account",
                MenuType.MENU,
                localization().storeMenu.account,
                Res.drawable.sale_menu_icon,
                StoreAccountNavRoute.HOME,
                Color(0xFFF5F5D5)
            )
        )

        val thirdMenu: ArrayList<BusinessMenu> = arrayListOf()

        thirdMenu.add(
            BusinessMenu(
                "my_business_app_dashboard",
                MenuType.MENU,
                localization().storeMenu.dashboard,
                Res.drawable.dashboard_menu_icon,
                BusinessStoreNavRoute.APP_DASHBOARD,
                Color(0xFFE2F1E9)
            )
        )
        val forthMenu: ArrayList<BusinessMenu> = arrayListOf()
        forthMenu.add(
            BusinessMenu(
                "my_business_theme",
                MenuType.MENU,
                "Theme Color",
                Res.drawable.colors,
                StoreNavRoute.COLOR,
                Color(0xFFF5F5D5)
            )
        )
//        val forthMenu: ArrayList<BusinessMenu> = arrayListOf()
//        forthMenu.add(
//            BusinessMenu(
//                "my_business_block_product",
//                MenuType.MENU,
//                localization().storeMenu.blockProduct,
//                Res.drawable.sale_menu_icon,
//                InventoryNavRoute.Product.BLOCKED,
//                Color(0xFFF5F5D5)
//            )
//        )

        val allMenuItems = listOf(
            BusinessMenu(
                "my_business_currency",
                MenuType.HEADER,
                "Online Store",
                Res.drawable.sale_menu_icon,
                StoreCurrencyNavRoute.HOME,
                Color(0xFFF5F5D5)
            ),
            BusinessMenu(
                "my_business_finance",
                MenuType.MENU,
                "",
                Res.drawable.shop_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFffffff),
                firstMenu
            ),
            BusinessMenu(
                "my_business_marketing",
                MenuType.HEADER,
                localization().storeMenu.finance,
                Res.drawable.shop_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFDEF4F8),
                secondMenu,
            ),
            BusinessMenu(
                "my_business_block",
                MenuType.HEADER,
                "Theme",
                Res.drawable.shop_menu_icon,
                BusinessNavRoute.STORE,
                Color(0xFFDEF4F8),
                forthMenu,
            ),
        )
        return allMenuItems
    }
}






























